<template>
  <svg aria-hidden="true" viewBox="0 0 1200 1200" ...attributes>
    <circle fill="#7DB9D8" cx="600" cy="600" r="30"></circle>
    <path
      fill="#1B2D3C"
      d="M980,620a20,20,0,0,0,0-40H920V520h60a20,20,0,0,0,0-40H920V470a20,20,0,0,0-40,0v10H820a20,20,0,0,0,0,40h60v60H820a20,20,0,0,0,0,40h60V802a100,100,0,1,0,40,0V620ZM960,900a60,60,0,1,1-60-60A60.07,60.07,0,0,1,960,900Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M380,620a20,20,0,0,0,0-40H320V398a100,100,0,1,0-40,0V580H220a20,20,0,0,0,0,40h60v60H220a20,20,0,0,0,0,40h60v10a20,20,0,0,0,40,0V720h60a20,20,0,0,0,0-40H320V620ZM240,300a60,60,0,1,1,60,60A60.07,60.07,0,0,1,240,300Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M900,200a100,100,0,0,0-98,80H620V220a20,20,0,0,0-40,0v60H520V220a20,20,0,0,0-40,0v60H470a20,20,0,0,0,0,40H802a100,100,0,1,0,98-120Zm0,160a60,60,0,1,1,60-60A60.07,60.07,0,0,1,900,360Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M730,880H398a100,100,0,1,0,0,40H580v60a20,20,0,0,0,40,0V920h60v60a20,20,0,0,0,40,0V920h10a20,20,0,0,0,0-40ZM300,960a60,60,0,1,1,60-60A60.07,60.07,0,0,1,300,960Z"
    ></path>
  </svg>
</template>
